/**
 * Employee Web — `/me/requests/$id` detail route (EW-11).
 *
 * Phase 4 Plan 04-04 Task 3. `?type=leave|overtime` search param drives the
 * fetch strategy inside <RequestDetailView> (leave → useLeaveRequest;
 * overtime → useOvertimeRequests list + client-side find by id, since no
 * dedicated useOvertimeRequest(id) hook ships until Phase 6.1).
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RequestDetailView } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/requests/$id")({
  staticData: { breadcrumb: { labelKey: "requests:page.detail" } },
  validateSearch: z.object({
    type: z.enum(["leave", "overtime"]).optional(),
  }),
  component: RequestDetailRoute,
});

function RequestDetailRoute(): JSX.Element {
  const { id } = Route.useParams();
  const { type } = Route.useSearch();
  // Pass `type` through undefined (don't default to "leave"): a notification
  // deep-link arrives with no `?type=`, and RequestDetailView resolves the kind
  // from the id so an overtime request no longer hits the leave endpoint (404).
  return <RequestDetailView requestId={id} type={type} />;
}
